import redirectList from './redirectList';

import { authenticated } from '../layouts/authenticated';

import AgencyOverviewPage from '../modules/agency/pages/AgencyOverviewPage';
import AgencyCreateProfilePage from '../modules/agency/pages/AgencyCreateProfilePage';
import AgencyProfilePage from '../modules/agency/pages/AgencyProfilePage';
import AgencyEditProfilePage from '../modules/agency/pages/AgencyEditProfilePage';
import AgencyBillingPage from '../modules/agency/pages/AgencyBillingPage';
import AgencySubscriptionsPage from '../modules/agency/pages/AgencySubscriptionsPage';

import InfluencersAgencyEditProfilePage from '../modules/influencers-agency/pages/InfluencersAgencyEditProfilePage';
import InfluencersAgencyProfilePage from '../modules/influencers-agency/pages/InfluencersAgencyProfilePage';
import InfluencersAgencyProfilesOverviewPage from '../modules/influencers-agency/pages/InfluencersAgencyProfilesOverviewPage';
import InfluencersAgencyBusinessDetailsPage from '../modules/influencers-agency/pages/InfluencersAgencyBusinessDetailsPage';
import InfluencersAgencyTeamMembersPage from '../modules/influencers-agency/pages/InfluencersAgencyTeamMembersPage';
import InfluencersAgencyCreateProfilePage from 'modules/influencers-agency/pages/influencers-agency-create-profile-page/InfluencersAgencyCreateProfilePage';
import InfluencersAgencyCreateMultiProfilePage from 'modules/influencers-agency/pages/influencers-agency-create-multi-profile-page/InfluencersAgencyCreateMultiProfile';

import BrandProfilePage from '../modules/brands/pages/BrandProfilePage';
import BrandViewProfilePage from '../modules/brands/pages/BrandViewProfilePage';
import BrandCreateProfilePage from '../modules/brands/pages/BrandCreateProfilePage';
import BrandEditProfilePage from '../modules/brands/pages/BrandEditProfilePage';
import BrandEditProfileAdminPage from '../modules/brands/pages/BrandEditProfileAdminPage';
import BrandViewProfileAdminPage from '../modules/brands/pages/BrandViewProfileAdminPage';

import CampaignsPageMixed from '../modules/organizations/pages/campaigns-mixed/CampaignsPageMixed';
import CcmCampaignOverviewPage from '../modules/organizations/pages/campaigns-mixed/ccm/overview/CcmCampaignOverviewPage';
import CcmCampaignOutfitsPage from '../modules/organizations/pages/campaigns-mixed/ccm/outfits/CcmCampaignOutfitsPage';
import CcmCampaignReportPage from '../modules/organizations/pages/campaigns-mixed/ccm/report/CcmCampaignReportPage';

import CampaignCreatePage from '../modules/campaigns/pages/CampaignCreatePage';
import CcmSelectCampaignCreatePage from 'modules/campaigns/pages/ccm/select-campaign-type/CcmSelectCampaignTypePage';
import CcmCampaignCreatePage from '../modules/campaigns/pages/ccm/create/CcmCampaignCreatePage';
import CampaignPaymentsPage from '../modules/campaigns/pages/payments/CampaignPaymentsPage';
import CcmCampaignPaymentsPage from '../modules/campaigns/pages/ccm/payments/CcmCampaignPaymentsPage';
import CampaignSubcampaignsPage from '../modules/campaigns/pages/CampaignSubcampaignsPage';
import SummaryPage from 'modules/reporting/pages/summary-page/SummaryPage';
import TikTokPage from 'modules/reporting/pages/tiktok-page/TikTokPage';
import CreatorPerformancePage from 'modules/reporting/pages/creator-performance-page/CreatorPerformancePage';
import OnsitePerformancePage from 'modules/reporting/pages/onsite-performance-page/OnsitePerformancePage';
import CCAReportingPage from 'modules/reporting/pages/cost-atribution-page/CostAttributionPage';
import IgPostPage from 'modules/reporting/pages/ig-post-page/IgPostPage';
import IgStoryPage from 'modules/reporting/pages/ig-story-page/IgStoryPage';
import IgReelPage from 'modules/reporting/pages/ig-reel-page/IgReelPage';
import ReportDownloadPage from 'modules/reporting/pages/report-download/ReportDownloadPage';
import ContentMetricsPage from 'modules/reporting/pages/content-metrics-page/ContentMetricsPage';
import CampaignDeliverablesPage from '../modules/campaigns/pages/CampaignDeliverablesPage';
import CampaignMessagesPage from '../modules/campaigns/pages/CampaignMessagesPage';
import CampaignProductListsPage from '../modules/campaigns/pages/CampaignProductListsPage';

import SubcampaignMessagesPage from '../modules/subcampaigns/pages/SubcampaignMessagesPage';
import SubcampaignPaymentsPage from '../modules/subcampaigns/pages/subcampaign-payments-page/SubcampaignPaymentsPage';

import SubcampaignOfferViewPage from '../modules/subcampaigns/pages/SubcampaignOfferViewPage';
import BrandSubcampaignOfferPage from '../modules/subcampaigns/pages/BrandSubcampaignOfferPage';

import LoginPage from '../modules/access/pages/LoginPage';
import SignUpPage from '../modules/access/pages/SignUpPage';
import SignUpSuccessfulPage from '../modules/access/pages/SignUpSuccessfulPage';
import InfluencerSignUpPage from '../modules/access/pages/InfluencerSignUpPage';
import PasswordResetPage from '../modules/access/pages/PasswordResetPage';
import RequestPasswordResetPage from 'modules/access/pages/request-password-reset-page/RequestPasswordResetPage';
import RequestActivationEmailPage from '../modules/access/pages/RequestActivationEmailPage';
import NewPasswordNotificationPage from '../modules/access/pages/NewPasswordNotificationPage';
import ActivateUserAccountPage from '../modules/access/pages/ActivateUserAccountPage';
import UnsubscribePage from '../modules/access/pages/UnsubscribePage';

import SelectOrganizationPage from 'modules/organizations/pages/SelectOrganizationPage';

import DiscoveryCreatorsPage from '../modules/discovery/creators/pages/DiscoveryCreatorsPage';
import DiscoveryContentPage from 'modules/discovery/content/pages/DiscoveryContentPage';

import ListsDashboardPage from '../modules/lists/pages/ListsDashboardPage';
import ListsViewPage from '../modules/lists/pages/ListsViewPage';
import ContentListsDashboardPage from '../modules/lists-content/pages/ContentListsDashboardPage';
import ContentListViewPage from '../modules/lists-content/pages/ContentListViewPage';

import ProposalCreatePage from 'modules/proposal/pages/proposal-create-page/ProposalCreatePage';

import HealthPage from 'modules/admin/pages/HealthPage';

import InfluencerCreateProfilePage from 'modules/influencers/pages/InfluencerCreateProfilePage';
import InfluencerEditProfilePage from 'modules/influencers/pages/InfluencerEditProfilePage';
import InfluencerProfilePage from 'modules/influencers/pages/InfluencerProfilePage';

import UserAccountPage from 'modules/user/pages/user-account-page/UserAccountPage';
import UserNotificationsPage from 'modules/user/pages/user-notifications-page/UserNotificationsPage';
import OrganizationBillingPage from 'modules/organizations/pages/organization-billing-page/OrganizationBillingPage';
import OrganizationSubscriptionsPage from 'modules/organizations/pages/OrganizationSubscriptionsPage';
import OrganizationTeamMembersPage from 'modules/organizations/pages/organization-team-members-page/OrganizationTeamMembersPage';

import InsightsReportsPage from 'modules/insights/reports/pages/InsightsReportsPage';
import InsightsReportsReportPageBase from 'modules/insights/reports/pages/report/base/InsightsReportsReportPageBase';

import SOVReportsPage from 'modules/insights/sov/pages/reports/SOVReportsPage';
import SOVReportPageBase from 'modules/insights/sov/pages/report/base/SOVReportPageBase';

import withSharedAccessAuthentication from 'modules/shared-access/components/WithSharedAccessAuthentication';
import SharedAccessPage from '../modules/shared-access/pages/SharedAccessPage';

import PageNotFound from '../components/page/page-not-found/PageNotFound';

import withConsumerInsightsAuthentication from 'modules/insights/sov/auth/consumer-insights/WithConsumerInsightsAuthentication';

import SOVBasePageConsumerInsights from 'modules/insights/sov/pages/consumer-insights/base/SOVBasePageConsumerInsights';
import SOVErrorPageConsumerInsights from 'modules/insights/sov/pages/consumer-insights/error/SOVErrorPageConsumerInsights';

import DeclineLightweightCampaignPage from 'modules/access/pages/DeclineLightweightCampaignPage';
import DeclineLightweightCampaignSuccessPage from 'modules/access/pages/DeclineLightweightCampaignSuccessPage';
import EmailUnsubscribeSuccessPage from 'modules/access/pages/EmailUnsubscribeSuccessPage';

import MiscDashboardPage from 'modules/misc/pages/misc-dashboard-page/MiscDashboardPage';
import AddZalandoBrandPage from 'modules/misc/pages/add-zalando-brand-page/AddZalandoBrandPage';

import AppStorePage from 'modules/access/pages/app-store-page/AppStorePage';

import { PAGE_TYPE } from 'utils/routes';
import { onEnterFrontPage, onEnterInternalPage, onEnterPublicPage } from 'utils/access';
import {
  ORGANIZATION_TYPE_BRAND as BRAND,
  ORGANIZATION_TYPE_BRAND_AGENCY as BRAND_AGENCY,
  ORGANIZATION_TYPE_CCM_ONLY as CCM_ONLY,
  ORGANIZATION_TYPE_INFLUENCER as INFLUENCER,
  ORGANIZATION_TYPE_INFLUENCERS_AGENCY as INFLUENCERS_AGENCY
} from 'utils/organization';
import SentimentAnalysisPage from 'modules/reporting/pages/sentiment-analysis-page/SentimentAnalysisPage';

export const redirects = () => (
  redirectList
);

export function routes() {
  const routeList = [
    {
      url: '/',
      component: LoginPage,
      pageType: PAGE_TYPE.ACCESS,
      onEnter: onEnterFrontPage
    },
    {
      url: '/login',
      component: LoginPage,
      pageType: PAGE_TYPE.ACCESS,
      onEnter: onEnterFrontPage
    },
    {
      url: '/accounts/:id/activate',
      component: ActivateUserAccountPage,
      pageType: PAGE_TYPE.ACCESS
    },
    {
      url: '/signup',
      component: SignUpPage,
      pageType: PAGE_TYPE.ACCESS,
      onEnter: onEnterFrontPage
    },
    {
      url: '/signup/success',
      component: SignUpSuccessfulPage,
      pageType: PAGE_TYPE.ACCESS,
      onEnter: onEnterFrontPage
    },
    {
      url: '/signup/content-creator',
      component: InfluencerSignUpPage,
      pageType: PAGE_TYPE.ACCESS,
      onEnter: onEnterFrontPage
    },
    {
      url: '/users/:id/password',
      component: PasswordResetPage,
      pageType: PAGE_TYPE.ACCESS
    },
    {
      url: '/users/:id/password/notification',
      component: NewPasswordNotificationPage,
      pageType: PAGE_TYPE.ACCESS
    },
    {
      url: '/users/request-password-reset',
      component: RequestPasswordResetPage,
      pageType: PAGE_TYPE.ACCESS
    },
    {
      url: '/users/request-activation-email',
      component: RequestActivationEmailPage,
      pageType: PAGE_TYPE.ACCESS
    },
    {
      url: '/app-store',
      component: AppStorePage,
      pageType: PAGE_TYPE.ACCESS
    },
    {
      url: '/admin/content-creators',
      onLazyImport: () => import(/* webpackChunkName: "module.admin" */ '../modules/admin/pages/InfluencerProfilesByApprovalStatusPage'),
      onLazyInit: (page) => authenticated(page, { adminOnly: true }),
      onEnter: onEnterInternalPage
    },
    {
      url: '/email-unsubscribe',
      component: UnsubscribePage,
      pageType: PAGE_TYPE.ACCESS,
      onEnter: onEnterFrontPage
    },
    {
      url: '/email-unsubscribe/success',
      component: EmailUnsubscribeSuccessPage,
      pageType: PAGE_TYPE.ACCESS,
      onEnter: onEnterFrontPage
    },
    {
      url: '/decline-invite',
      component: DeclineLightweightCampaignPage,
      pageType: PAGE_TYPE.ACCESS,
      onEnter: onEnterFrontPage
    },
    {
      url: '/decline-invite/success',
      component: DeclineLightweightCampaignSuccessPage,
      pageType: PAGE_TYPE.ACCESS,
      onEnter: onEnterFrontPage
    },
    {
      url: '/admin/brands',
      onLazyImport: () => import(/* webpackChunkName: "module.admin" */ '../modules/admin/pages/BrandProfilesByApprovalStatusPage'),
      onLazyInit: (page) => authenticated(page, { adminOnly: true, allowForRoles: ['CCM_MODERATOR'] }),
      onEnter: onEnterInternalPage
    },
    {
      url: '/admin/organizations',
      onLazyImport: () => import(/* webpackChunkName: "module.admin" */ '../modules/admin/pages/OrganizationsByTypePage'),
      onLazyInit: (page) => authenticated(page, { adminOnly: true, allowForRoles: ['CCM_MODERATOR'] }),
      onEnter: onEnterInternalPage
    },
    {
      url: '/admin/organizations/:orgId/team-members',
      onLazyImport: () => import(/* webpackChunkName: "module.admin" */ '../modules/admin/pages/OrganizationTeamMembersPage'),
      onLazyInit: (page) => authenticated(page, { adminOnly: true, allowForRoles: ['CCM_MODERATOR'] }),
      onEnter: onEnterInternalPage
    },
    {
      url: '/admin/organizations/:orgId/subscription',
      onLazyImport: () => import(/* webpackChunkName: "module.admin" */ '../modules/admin/pages/OrganizationSubscriptionPage'),
      onLazyInit: (page) => authenticated(page, { adminOnly: true, allowForRoles: ['CCM_MODERATOR'] }),
      onEnter: onEnterInternalPage
    },
    {
      url: '/admin/brand/profiles/:id/zalando-brands',
      onLazyImport: () => import(/* webpackChunkName: "module.admin" */ '../modules/admin/pages/EditZalandoBrandsPage'),
      onLazyInit: (page) => authenticated(page, { adminOnly: true, allowForRoles: ['CCM_MODERATOR'] }),
      onEnter: onEnterInternalPage
    },
    {
      url: '/admin/organizations/create',
      onLazyImport: () => import(/* webpackChunkName: "module.admin" */ '../modules/admin/pages/CreateBrandOrganizationPage'),
      onLazyInit: (page) => authenticated(page, { adminOnly: true, allowForRoles: ['CCM_MODERATOR'] }),
      onEnter: onEnterInternalPage
    },
    {
      url: '/admin/agencies/create',
      onLazyImport: () => import(/* webpackChunkName: "module.admin" */ '../modules/admin/pages/CreateAgencyPage'),
      onLazyInit: (page) => authenticated(page, { adminOnly: true }),
      onEnter: onEnterInternalPage
    },
    {
      url: '/admin/agencies',
      onLazyImport: () => import(/* webpackChunkName: "module.admin" */ '../modules/admin/pages/AgenciesPage'),
      onLazyInit: (page) => authenticated(page, { adminOnly: true }),
      onEnter: onEnterInternalPage
    },
    {
      url: '/admin/influencers-agencies/create',
      onLazyImport: () => import(/* webpackChunkName: "module.admin" */ '../modules/admin/pages/influencers-agencies/CreateInfluencersAgencyPage'),
      onLazyInit: (page) => authenticated(page, { adminOnly: true }),
      onEnter: onEnterInternalPage
    },
    {
      url: '/admin/influencers-agencies',
      onLazyImport: () => import(/* webpackChunkName: "module.admin" */ '../modules/admin/pages/influencers-agencies/InfluencersAgenciesPage'),
      onLazyInit: (page) => authenticated(page, { adminOnly: true }),
      onEnter: onEnterInternalPage
    },
    {
      url: '/admin/users',
      onLazyImport: () => import(/* webpackChunkName: "module.admin" */ '../modules/admin/pages/UsersPage'),
      onLazyInit: (page) => authenticated(page, { adminOnly: true }),
      onEnter: onEnterInternalPage
    },
    {
      url: '/admin/delete-user',
      onLazyImport: () => import(/* webpackChunkName: "module.admin" */ '../modules/admin/pages/delete-user/DeleteUserPage'),
      onLazyInit: (page) => authenticated(page, { adminOnly: true }),
      onEnter: onEnterInternalPage
    },
    {
      url: '/admin/campaigns',
      onLazyImport: () => import(/* webpackChunkName: "module.admin" */ '../modules/admin/pages/CampaignsPage'),
      onLazyInit: (page) => authenticated(page, { adminOnly: true, allowForRoles: ['CCM_MODERATOR'] }),
      onEnter: onEnterInternalPage
    },
    {
      url: '/admin/channels',
      onLazyImport: () => import(/* webpackChunkName: "module.admin" */ '../modules/admin/pages/ChannelsPage'),
      onLazyInit: (page) => authenticated(page, { adminOnly: true, allowForRoles: ['CCM_MODERATOR'] }),
      onEnter: onEnterInternalPage
    },
    {
      url: '/admin/realm-outfits',
      onLazyImport: () => import(/* webpackChunkName: "module.admin" */ '../modules/admin/pages/realm-outfits-page/RealmOutfitsPage'),
      onLazyInit: (page) => authenticated(page, { adminOnly: true, allowForRoles: ['INFLUENCER_REALM'] }),
      onEnter: onEnterInternalPage
    },
    {
      url: '/admin/realm-profiles',
      onLazyImport: () => import(/* webpackChunkName: "module.admin" */ '../modules/admin/pages/realm-profiles-page/RealmProfilesPage'),
      onLazyInit: (page) => authenticated(page, { adminOnly: true, allowForRoles: ['INFLUENCER_REALM', 'CCM_MODERATOR'] }),
      onEnter: onEnterInternalPage
    },
    {
      url: '/admin',
      onLazyImport: () => import(/* webpackChunkName: "module.admin" */ '../modules/admin/pages/admin-dashboard-page/AdminDashboardPage'),
      onLazyInit: (page) => authenticated(page, { adminOnly: true, allowForRoles: ['INFLUENCER_REALM', 'PAYOUT_REALM', 'CCM_MODERATOR'] }),
      onEnter: onEnterInternalPage
    },
    {
      url: '/admin/sap-report',
      onLazyImport: () => import(/* webpackChunkName: "module.admin" */ '../modules/admin/pages/sap-report-page/SAPReportPage'),
      onLazyInit: (page) => authenticated(page, { adminOnly: true, allowForRoles: ['PAYOUT_REALM'] }),
      onEnter: onEnterInternalPage
    },
    {
      url: '/admin/payouts',
      onLazyImport: () => import(/* webpackChunkName: "module.admin" */ '../modules/admin/payouts/pages/PayoutsPage'),
      onLazyInit: (page) => authenticated(page, { adminOnly: true, allowForRoles: ['PAYOUT_REALM'] }),
      onEnter: onEnterInternalPage
    },
    {
      url: '/admin/payment-overview',
      onLazyImport: () => import(/* webpackChunkName: "module.admin" */ '../modules/admin/payment-overview/PaymentOverviewPage'),
      onLazyInit: (page) => authenticated(page, { allowRoleOnly: true, allowForRoles: ['PAYOUT_REALM'] }),
      onEnter: onEnterInternalPage
    },
    {
      url: '/admin/agency/:id/overview',
      component: authenticated(AgencyOverviewPage, {
        protectFrom: [INFLUENCER, CCM_ONLY]
      }),
      onEnter: onEnterInternalPage
    },
    {
      url: '/:admin?/agency/:id/settings/profile',
      component: authenticated(AgencyProfilePage, {
        protectFrom: [INFLUENCER, CCM_ONLY],
        allowForFreemiumBrandProfile: true
      }),
      onEnter: onEnterInternalPage
    },
    {
      url: '/:admin?/agency/:id/settings/profile/edit',
      component: authenticated(AgencyEditProfilePage, {
        protectFrom: [INFLUENCER, CCM_ONLY],
        allowForFreemiumBrandProfile: true
      }),
      onEnter: onEnterInternalPage
    },
    {
      url: '/:admin?/agency/:id/settings/details',
      component: authenticated(AgencyBillingPage, {
        protectFrom: [INFLUENCER, CCM_ONLY],
        allowForFreemiumBrandProfile: true
      }),
      onEnter: onEnterInternalPage
    },
    {
      url: '/:admin?/agency/:id/settings/subscriptions',
      component: authenticated(AgencySubscriptionsPage, {
        protectFrom: [INFLUENCER, CCM_ONLY],
        allowForFreemiumBrandProfile: true
      }),
      onEnter: onEnterInternalPage
    },
    {
      url: '/:admin?/influencers-agencies/:id/settings/profile/edit',
      component: authenticated(InfluencersAgencyEditProfilePage, {
        protectFrom: [INFLUENCER, CCM_ONLY]
      }),
      onEnter: onEnterInternalPage
    },
    {
      url: '/:admin?/influencers-agencies/:id/settings/profile',
      component: authenticated(InfluencersAgencyProfilePage, {
        protectFrom: [INFLUENCER, CCM_ONLY]
      }),
      onEnter: onEnterInternalPage
    },
    {
      url: '/:admin?/influencers-agencies/:id/settings/add-new-profiles',
      component: authenticated(InfluencersAgencyCreateMultiProfilePage, {
        protectFrom: [INFLUENCER, CCM_ONLY]
      }),
      onEnter: onEnterInternalPage
    },
    {
      url: '/:admin?/influencers-agencies/:id/settings/create-new-profile',
      component: authenticated(InfluencersAgencyCreateProfilePage, {
        protectFrom: [INFLUENCER, CCM_ONLY]
      }),
      onEnter: onEnterInternalPage
    },
    {
      url: '/:admin?/influencers-agencies/:id/settings/profiles-overview',
      component: authenticated(InfluencersAgencyProfilesOverviewPage, {
        protectFrom: [INFLUENCER, CCM_ONLY]
      }),
      onEnter: onEnterInternalPage
    },
    {
      url: '/:admin?/influencers-agencies/:id/settings/business-details',
      component: authenticated(InfluencersAgencyBusinessDetailsPage, {
        protectFrom: [INFLUENCER, CCM_ONLY]
      }),
      onEnter: onEnterInternalPage
    },
    {
      url: '/:admin?/influencers-agencies/:id/settings/team-members',
      component: authenticated(InfluencersAgencyTeamMembersPage, {
        protectFrom: [INFLUENCER, CCM_ONLY]
      }),
      onEnter: onEnterInternalPage
    },
    {
      url: '/discovery/creators',
      component: authenticated(DiscoveryCreatorsPage, {
        protectFrom: [INFLUENCER, INFLUENCERS_AGENCY, CCM_ONLY],
        allowOnlyForApprovedProfile: true,
        allowForFreemiumBrandProfile: true
      }),
      onEnter: onEnterInternalPage
    },
    {
      url: '/discovery/content',
      component: authenticated(DiscoveryContentPage, {
        protectFrom: [INFLUENCER, INFLUENCERS_AGENCY, CCM_ONLY],
        allowOnlyForApprovedProfile: true
      }),
      onEnter: onEnterInternalPage
    },
    {
      url: '/content-creator/profiles/:id/edit',
      component: authenticated(InfluencerEditProfilePage, {
        protectFrom: [BRAND, BRAND_AGENCY, CCM_ONLY]
      }),
      onEnter: onEnterInternalPage
    },
    {
      url: '/agency/:id/create',
      component: authenticated(AgencyCreateProfilePage, {
        protectFrom: [CCM_ONLY],
        allowForFreemiumBrandProfile: true
      }),
      onEnter: onEnterInternalPage
    },
    {
      url: '/agency/:id/overview',
      component: authenticated(AgencyOverviewPage, {
        protectFrom: [INFLUENCER, CCM_ONLY],
        allowForFreemiumBrandProfile: true
      }),
      onEnter: onEnterInternalPage
    },
    {
      url: '/agency/:id/settings/profile',
      component: authenticated(AgencyProfilePage, {
        protectFrom: [INFLUENCER],
        allowForFreemiumBrandProfile: true
      }),
      onEnter: onEnterInternalPage
    },

    {
      url: '/agency/:id/settings/profile/edit',
      component: authenticated(AgencyEditProfilePage, {
        protectFrom: [INFLUENCER],
        allowForFreemiumBrandProfile: true
      }),
      onEnter: onEnterInternalPage
    },

    {
      url: '/agency/:id/settings/details',
      component: authenticated(AgencyBillingPage, {
        protectFrom: [INFLUENCER],
        allowForFreemiumBrandProfile: true
      }),
      onEnter: onEnterInternalPage
    },

    {
      url: '/agency/:id/settings/subscriptions',
      component: authenticated(AgencySubscriptionsPage, {
        protectFrom: [INFLUENCER],
        allowForFreemiumBrandProfile: true
      }),
      onEnter: onEnterInternalPage
    },
    {
      url: '/organizations/:id/content-creators/create',
      component: authenticated(InfluencerCreateProfilePage, {
        protectFrom: [BRAND, CCM_ONLY]
      }),
      onEnter: onEnterInternalPage,
      pageType: PAGE_TYPE.EMPTY
    },
    {
      url: '/content-creator/profiles/:id',
      component: authenticated(InfluencerProfilePage, {
        allowForFreemiumBrandProfile: true
      }),
      onEnter: onEnterInternalPage
    },
    {
      url: '/organizations/:id/brands/create',
      component: authenticated(BrandCreateProfilePage, {
        protectFrom: [INFLUENCER, INFLUENCERS_AGENCY],
        allowForFreemiumBrandProfile: true,
        allowForCcmOnlyBrandProfile: true
      }),
      onEnter: onEnterInternalPage
    },
    {
      url: '/brand/profiles/:id/campaigns/ccm/create',
      component: authenticated(CcmCampaignCreatePage, {
        protectFrom: [INFLUENCER, INFLUENCERS_AGENCY],
        protectFromNonCcmBrands: true,
        allowOnlyForApprovedProfile: true
      }),
      onEnter: onEnterInternalPage
    },
    {
      url: '/brand/profiles/:id/campaigns/ccm/select-campaign-type',
      component: authenticated(CcmSelectCampaignCreatePage, {
        protectFrom: [INFLUENCER, INFLUENCERS_AGENCY],
        protectFromNonCcmBrands: true,
        allowOnlyForApprovedProfile: true
      }),
      onEnter: onEnterInternalPage
    },
    {
      url: '/brand/profiles/:id/campaigns/create',
      component: authenticated(CampaignCreatePage, {
        protectFrom: [INFLUENCER, INFLUENCERS_AGENCY, CCM_ONLY],
        allowOnlyForApprovedProfile: true
      }),
      onEnter: onEnterInternalPage
    },
    {
      url: '/campaigns/:id/report/v2',
      component: authenticated(SummaryPage, {
        protectFrom: [INFLUENCER, INFLUENCERS_AGENCY, CCM_ONLY],
        allowOnlyForApprovedProfile: true
      }),
      onEnter: onEnterInternalPage
    },
    {
      url: '/campaigns/:id/report/v2/tiktok',
      component: authenticated(TikTokPage, {
        protectFrom: [INFLUENCER, INFLUENCERS_AGENCY, CCM_ONLY],
        allowOnlyForApprovedProfile: true
      }),
      onEnter: onEnterInternalPage
    },
    {
      url: '/campaigns/:id/report/v2/cca',
      component: authenticated(CCAReportingPage, {
        protectFrom: [INFLUENCER, INFLUENCERS_AGENCY, CCM_ONLY],
        allowOnlyForApprovedProfile: true
      }),
      onEnter: onEnterInternalPage
    },
    {
      url: '/campaigns/:id/report/v2/ig-post',
      component: authenticated(IgPostPage, {
        protectFrom: [INFLUENCER, INFLUENCERS_AGENCY, CCM_ONLY],
        allowOnlyForApprovedProfile: true
      }),
      onEnter: onEnterInternalPage
    },
    {
      url: '/campaigns/:id/report/v2/creators',
      component: authenticated(CreatorPerformancePage, {
        protectFrom: [INFLUENCER, INFLUENCERS_AGENCY, CCM_ONLY],
        allowOnlyForApprovedProfile: true
      }),
      onEnter: onEnterInternalPage
    },
    {
      url: '/campaigns/:id/report/v2/onsite-performance',
      component: authenticated(OnsitePerformancePage, {
        protectFrom: [INFLUENCER, INFLUENCERS_AGENCY, CCM_ONLY],
        allowOnlyForApprovedProfile: true
      }),
      onEnter: onEnterInternalPage
    },
    {
      url: '/campaigns/:id/report/v2/ig-stories',
      component: authenticated(IgStoryPage, {
        protectFrom: [INFLUENCER, INFLUENCERS_AGENCY, CCM_ONLY],
        allowOnlyForApprovedProfile: true
      }),
      onEnter: onEnterInternalPage
    },
    {
      url: '/campaigns/:id/report/v2/ig-reels',
      component: authenticated(IgReelPage, {
        protectFrom: [INFLUENCER, INFLUENCERS_AGENCY, CCM_ONLY],
        allowOnlyForApprovedProfile: true
      }),
      onEnter: onEnterInternalPage
    },
    {
      url: '/campaigns/:id/report/v2/download',
      component: authenticated(ReportDownloadPage, {
        protectFrom: [INFLUENCER, INFLUENCERS_AGENCY],
        allowOnlyForApprovedProfile: true
      }),
      onEnter: onEnterInternalPage
    },
    {
      url: '/campaigns/:id/report/v2/content-metrics',
      component: authenticated(ContentMetricsPage, {
        protectFrom: [INFLUENCER, INFLUENCERS_AGENCY, CCM_ONLY],
        allowOnlyForApprovedProfile: true
      }),
      onEnter: onEnterInternalPage
    },
    {
      url: '/campaigns/:id/report/v2/sentiment-analysis',
      component: authenticated(SentimentAnalysisPage, {
        protectFrom: [INFLUENCER, INFLUENCERS_AGENCY, CCM_ONLY],
        allowOnlyForApprovedProfile: true
      }),
      onEnter: onEnterInternalPage
    },
    {
      url: '/campaigns/:id/payments',
      component: authenticated(CampaignPaymentsPage, {
        protectFrom: [INFLUENCER, INFLUENCERS_AGENCY, CCM_ONLY],
        allowOnlyForApprovedProfile: true
      }),
      onEnter: onEnterInternalPage
    },
    {
      url: '/campaigns/:id/participants/:participantType',
      component: authenticated(CampaignSubcampaignsPage, {
        protectFrom: [INFLUENCER, INFLUENCERS_AGENCY, CCM_ONLY],
        allowOnlyForApprovedProfile: true
      }),
      onEnter: onEnterInternalPage
    },
    {
      url: '/campaigns/ccm/:id/participants/:participantType',
      component: authenticated(CcmCampaignOverviewPage, {
        protectFromNonCcmBrands: true
      }),
      onEnter: onEnterInternalPage
    },
    {
      url: '/campaigns/:id/messages',
      component: authenticated(CampaignMessagesPage, {
        allowOnlyForApprovedProfile: true
      }),
      onEnter: onEnterInternalPage
    },
    {
      url: '/campaigns/ccm/:id/messages',
      component: authenticated(CampaignMessagesPage, {
        allowOnlyForApprovedProfile: true
      }),
      onEnter: onEnterInternalPage
    },
    {
      url: '/campaigns/:id/product-lists',
      component: authenticated(CampaignProductListsPage, {
        protectFrom: [CCM_ONLY],
        allowOnlyForApprovedProfile: true
      }),
      onEnter: onEnterInternalPage
    },
    {
      url: '/campaigns/:id/deliverables',
      component: authenticated(CampaignDeliverablesPage, {
        protectFrom: [CCM_ONLY],
        allowOnlyForApprovedProfile: true
      }),
      onEnter: onEnterInternalPage
    },
    {
      url: '/campaigns/ccm/:id/deliverables',
      component: authenticated(CampaignDeliverablesPage, {
        allowOnlyForApprovedProfile: true
      }),
      onEnter: onEnterInternalPage
    },
    {
      url: '/campaigns/:id/details/:subcampaignId',
      component: authenticated(SubcampaignOfferViewPage, {
        protectFrom: [BRAND, BRAND_AGENCY, CCM_ONLY],
        protectFromPendingProfiles: true
      }),
      onEnter: onEnterInternalPage
    },
    {
      url: '/campaigns/:id/details/:subcampaignId/messages',
      component: authenticated(SubcampaignMessagesPage, {
        protectFrom: [BRAND, BRAND_AGENCY, CCM_ONLY],
        allowOnlyForApprovedProfile: true
      }),
      onEnter: onEnterInternalPage
    },
    {
      url: '/campaigns/:id/details/:subcampaignId/payments',
      component: authenticated(SubcampaignPaymentsPage, {
        protectFrom: [BRAND, BRAND_AGENCY, CCM_ONLY],
        protectFromPendingProfiles: true
      }),
      onEnter: onEnterInternalPage
    },
    {
      url: '/campaigns/:id/dashboard',
      component: PageNotFound,
      onEnter: onEnterInternalPage
    },
    {
      url: '/campaigns/:id/offers',
      component: authenticated(SubcampaignOfferViewPage, {
        protectFrom: [INFLUENCER, INFLUENCERS_AGENCY, CCM_ONLY],
        protectFromPendingProfiles: true
      }),
      onEnter: onEnterInternalPage
    },
    {
      url: '/campaigns/:id/subcampaigns/:subcampaignId',
      component: authenticated(BrandSubcampaignOfferPage, {
        protectFrom: [INFLUENCER, INFLUENCERS_AGENCY, CCM_ONLY],
        protectFromPendingProfiles: true
      }),
      onEnter: onEnterInternalPage
    },
    {
      url: '/campaigns/:id/subcampaigns/:subcampaignId/edit',
      component: authenticated(BrandSubcampaignOfferPage, {
        protectFrom: [INFLUENCER, INFLUENCERS_AGENCY, CCM_ONLY],
        protectFromPendingProfiles: true
      }),
      onEnter: onEnterInternalPage
    },
    {
      url: '/health',
      component: HealthPage,
      onEnter: onEnterPublicPage
    },
    {
      url: '/user/settings',
      component: UserAccountPage,
      onEnter: onEnterInternalPage
    },
    {
      url: '/user/settings/email-notifications',
      component: authenticated(UserNotificationsPage, {
        protectFrom: [INFLUENCER, INFLUENCERS_AGENCY],
        allowOnlyForApprovedProfile: true,
        allowForFreemiumBrandProfile: true,
        allowForCcmOnlyBrandProfile: true
      }),
      onEnter: onEnterInternalPage
    },
    {
      url: '/brand/profiles/:id/',
      component: authenticated(BrandViewProfilePage),
      onEnter: onEnterInternalPage
    },
    {
      url: '/organizations/:id/brand/settings',
      component: authenticated(BrandProfilePage, {
        protectFrom: [INFLUENCER, INFLUENCERS_AGENCY],
        allowForFreemiumBrandProfile: true
      }),
      onEnter: onEnterInternalPage
    },
    {
      url: '/organizations/:id/brand/settings/edit',
      component: authenticated(BrandEditProfilePage, {
        protectFrom: [INFLUENCER, INFLUENCERS_AGENCY],
        allowForFreemiumBrandProfile: true
      }),
      onEnter: onEnterInternalPage
    },
    {
      url: '/admin/brand/profiles/:id/settings/edit',
      component: authenticated(BrandEditProfileAdminPage, {
        protectFrom: [INFLUENCER, INFLUENCERS_AGENCY]
      }),
      onEnter: onEnterInternalPage
    },
    {
      url: '/admin/brand/profiles/:id',
      component: authenticated(BrandViewProfileAdminPage, {
        protectFrom: [INFLUENCER, INFLUENCERS_AGENCY]
      }),
      onEnter: onEnterInternalPage
    },
    {
      url: '/organizations/:id/settings/subscriptions',
      component: authenticated(OrganizationSubscriptionsPage, {
        protectFrom: [INFLUENCER, INFLUENCERS_AGENCY],
        allowOnlyForApprovedProfile: true,
        protectFromAgencyChild: true,
        allowForFreemiumBrandProfile: true
      }),
      onEnter: onEnterInternalPage
    },
    {
      url: '/organizations/:id/settings/team-members',
      component: authenticated(OrganizationTeamMembersPage, {
        allowForFreemiumBrandProfile: true,
        allowForCcmOnlyBrandProfile: true
      }),
      onEnter: onEnterInternalPage
    },
    {
      url: '/organizations/:id/settings/details',
      component: authenticated(OrganizationBillingPage, {
        protectFromAgencyChild: true,
        allowForFreemiumBrandProfile: true
      }),
      onEnter: onEnterInternalPage
    },
    {
      url: '/organizations/:id/campaigns',
      component: authenticated(CampaignsPageMixed),
      onEnter: onEnterInternalPage
    },
    {
      url: '/campaigns/ccm/:id/overview',
      component: authenticated(CcmCampaignOverviewPage, {
        protectFromNonCcmBrands: true
      }),
      onEnter: onEnterInternalPage
    },
    {
      url: '/campaigns/ccm/:id/subcampaigns/:subcampaignId',
      component: authenticated(CcmCampaignOverviewPage, {
        protectFromNonCcmBrands: true
      }),
      onEnter: onEnterInternalPage
    },
    {
      url: '/campaigns/ccm/:id/outfits',
      component: authenticated(CcmCampaignOutfitsPage, {
        protectFromNonCcmBrands: true
      }),
      onEnter: onEnterInternalPage
    },
    {
      url: '/campaigns/ccm/:id/report',
      component: authenticated(CcmCampaignReportPage, {
        protectFromNonCcmBrands: true
      }),
      onEnter: onEnterInternalPage
    },
    {
      url: '/campaigns/ccm/:id/payments',
      component: authenticated(CcmCampaignPaymentsPage, {
        protectFrom: [INFLUENCERS_AGENCY, INFLUENCER]
      }),
      onEnter: onEnterInternalPage
    },
    {
      url: '/select-organization',
      component: authenticated(SelectOrganizationPage),
      onEnter: onEnterInternalPage
    },
    {
      url: '/collections/creators',
      component: authenticated(ListsDashboardPage, {
        protectFrom: [INFLUENCER, INFLUENCERS_AGENCY, CCM_ONLY],
        allowOnlyForApprovedProfile: true
      }),
      onEnter: onEnterInternalPage
    },
    {
      url: '/collections/creators/:listId',
      component: authenticated(ListsViewPage, {
        protectFrom: [INFLUENCER, INFLUENCERS_AGENCY, CCM_ONLY],
        allowOnlyForApprovedProfile: true
      }),
      onEnter: onEnterInternalPage
    },
    {
      url: '/collections/creators/:listId/proposal',
      component: authenticated(ProposalCreatePage, {
        protectFrom: [INFLUENCER, INFLUENCERS_AGENCY, CCM_ONLY],
        allowOnlyForApprovedProfile: true
      }),
      onEnter: onEnterInternalPage
    },
    {
      url: '/collections/content',
      component: authenticated(ContentListsDashboardPage, {
        protectFrom: [INFLUENCER, INFLUENCERS_AGENCY, CCM_ONLY],
        allowOnlyForApprovedProfile: true
      }),
      onEnter: onEnterInternalPage
    },
    {
      url: '/collections/content/:listId',
      component: authenticated(ContentListViewPage, {
        protectFrom: [INFLUENCER, INFLUENCERS_AGENCY, CCM_ONLY],
        allowOnlyForApprovedProfile: true
      }),
      onEnter: onEnterInternalPage
    },
    {
      url: '/insights/sov',
      component: authenticated(SOVReportsPage, {
        protectFrom: [INFLUENCER, INFLUENCERS_AGENCY, CCM_ONLY],
        allowOnlyForApprovedProfile: true
      }),
      onEnter: onEnterInternalPage
    },
    {
      url: '/insights/sov/:reportType/:reportId',
      component: authenticated(SOVReportPageBase, {
        protectFrom: [INFLUENCER, INFLUENCERS_AGENCY, CCM_ONLY],
        allowOnlyForApprovedProfile: true,
        allowForFreemiumBrandProfile: true
      }),
      onEnter: onEnterInternalPage
    },
    {
      url: '/insights/reports',
      component: authenticated(InsightsReportsPage, {
        protectFrom: [INFLUENCER, INFLUENCERS_AGENCY, CCM_ONLY],
        allowOnlyForApprovedProfile: true
      }),
      onEnter: onEnterInternalPage
    },
    {
      url: '/insights/reports/:reportType/:reportId',
      component: authenticated(InsightsReportsReportPageBase, {
        protectFrom: [INFLUENCER, INFLUENCERS_AGENCY, CCM_ONLY],
        allowOnlyForApprovedProfile: true,
        allowForFreemiumBrandProfile: true
      }),
      onEnter: onEnterInternalPage
    },
    {
      url: '/shared-access/:id',
      component: withSharedAccessAuthentication()(SharedAccessPage),
      pageType: PAGE_TYPE.SHARED_ACCESS
    },
    {
      url: '/consumer-insights/sov',
      component: withConsumerInsightsAuthentication()(SOVBasePageConsumerInsights),
      pageType: PAGE_TYPE.CONSUMER_INSIGHTS
    },
    {
      url: '/consumer-insights/sov/v2',
      component: withConsumerInsightsAuthentication()(SOVBasePageConsumerInsights),
      pageType: PAGE_TYPE.CONSUMER_INSIGHTS
    },
    {
      url: '/consumer-insights/sov/error',
      component: withConsumerInsightsAuthentication()(SOVErrorPageConsumerInsights),
      pageType: PAGE_TYPE.CONSUMER_INSIGHTS
    },
    {
      url: '/consumer-insights/sov/:reportType/:reportId',
      component: withConsumerInsightsAuthentication()(SOVReportPageBase),
      pageType: PAGE_TYPE.CONSUMER_INSIGHTS
    },
    {
      url: '/miscellaneous',
      component: authenticated(
        MiscDashboardPage,
        {
          protectFrom: [CCM_ONLY],
          allowForFreemiumBrandProfile: true,
          withAccessToMiscellaneous: true
        }
      ),
      onEnter: onEnterInternalPage
    },
    {
      url: '/miscellaneous/add-brands',
      component: authenticated(
        AddZalandoBrandPage,
        {
          protectFrom: [CCM_ONLY],
          allowForFreemiumBrandProfile: true,
          withAccessToMiscellaneous: true
        }
      ),
      onEnter: onEnterInternalPage
    },
    {
      url: '/404',
      component: PageNotFound,
      onEnter: onEnterPublicPage
    },
    {
      url: '*',
      component: PageNotFound,
      onEnter: onEnterPublicPage
    }
  ];

  return routeList;
}
